// TODO change to user role
import { toast } from 'react-toastify';

export enum UserType {
  STUDENT = 'student',
  ADMINISTRATION = 'administration',
  LECTURER = 'lecturer',
}

export const getUserTypeDisplayTextName = (userType: UserType) => {
  switch (userType) {
    case UserType.ADMINISTRATION:
      return `מנהל`;
    case UserType.STUDENT:
      return `סטודנט`;
    case UserType.LECTURER:
      return `מרצה`;
  }
};
